import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";
import { useAppointmentNoShowNotificationQuery } from "../../../../../../../api/appointments/useAppointmentNoShowNotificationQuery";

export function useNoShowNotificationFlow() {
  const { modals, appointment } = useContext();

  const { data: notification, isLoading } =
    useAppointmentNoShowNotificationQuery({
      appointmentId: appointment.id,
    });

  const start = ({ charge, isAdditionalProvider } = {}) => {
    if (!notification) {
      return uiNotification.error(
        "Unable to load no-shows notification details. Try again later.",
      );
    }
    if (notification.needToShow) {
      modals.noShowNotification.open({
        charge,
        isAdditionalProvider,
      });
    } else {
      modals.confirmNoShow.open({ charge, isAdditionalProvider });
    }
  };

  return {
    start,
    isLoading,
  };
}
